import api from './client';

export const getLoadCalc     = (projectId) => api.get('/load-calc', { params: { project: projectId } });
export const setBoardFeed    = (switchboardId, data) => api.put(`/load-calc/feed/${switchboardId}`, data);  // { fedFrom?, incomingBreaker? }
export const getPowerSources = (projectId) => api.get('/load-calc/sources', { params: { project: projectId } });
export const createPowerSource = (data) => api.post('/load-calc/sources', data);
export const updatePowerSource = (id, data) => api.put(`/load-calc/sources/${id}`, data);
export const deletePowerSource = (id) => api.delete(`/load-calc/sources/${id}`);
